export class TrimmedKeyMap<V> {
	private map = new Map<string, V>();

	public set(key: string, value: V): this {
		const trimmedKey = key?.trim();
		if (trimmedKey) {
			this.map.set(trimmedKey, value);
		}
		return this;
	}

	public get(key: string): V | undefined {
		return this.map.get(key?.trim());
	}

	public has(key: string): boolean {
		return this.map.has(key?.trim());
	}

	public delete(key: string): boolean {
		return this.map.delete(key?.trim());
	}

	public forEach(callbackfn: (value: V, key: string, map: Map<string, V>) => void): void {
		this.map.forEach(callbackfn);
	}

	public get size(): number {
		return this.map.size;
	}
}
